export default __webpack_public_path__ + "img/120a7473a9c7e63ffdaf15ee92f5249b.png";